// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vas-trans .card-summary {
  background-color: #ffffff;
  display: flex;
  padding: 20px;
  border-radius: 7px;
}

.vas-trans .card-summary p {
  margin-bottom: 0;
}

.vas-trans .summary-icon {
  margin-right: auto;
  margin-left: 0;
}

.vas-trans .summary-icon img {
  width: 50px;
}

.vas-trans .data {
  text-align: end;
  font-size: 10px;
}

.vas-trans .data .amount {
  font-size: 18px;
  letter-spacing: 0.1px;
  color: #000000;
}

.vas-trans .select-icon .service-logo {
  background-repeat: no-repeat;
  background-size: cover;
  height: 25px;
  width: 25px;
  border-radius: 50%;
}

.vas-trans .data .amount span {
  font-weight: 600;
  margin-left: 2px;
}

.vas-trans .downloads {
  margin-left: 26px;
  border: none;
  padding: 0;
}

.vas-trans .downloads img {
  height: 46px;
}

.vas-trans .date-filter {
  display: flex;
  align-items: center;
}

.vas-trans .date-filter p {
  margin-bottom: 0;
  margin-right: 5px;
  font-size: 10px;
}

.vas-trans .vas-table {
  background-color: #ffffff;
  margin-top: 30px;
}

.vas-trans .vas-table .btn {
    font-size: 10px;
    height: fit-content;
    padding: 8px;
  }

/* .vas-trans .vas-table thead {
    height: 40px;
    background-color: #9595954E;
} */

.vas-trans .filter {
  background-color: transparent;
  color: #060d27;
  border: 1px solid #060d27;
  height: 44px;
  padding-inline: 20px;
  margin-left: auto;
}

.vas-trans .filter:hover {
  color: #060d27;
}

.vas-trans .filter-data {
  display: flex;
  margin-bottom: 0;
  gap: 0;
}

.vas-trans .filter-data .grouped-input {
  margin-inline: 12px;
}

.vas-trans .modal .transaction-info {
  display: flex;
  font-size: 14px;
  font-weight: 100;
  text-align: left;
  gap: 20px;
}

.vas-trans .modal .info-section .info-item {
    margin-bottom: 20px;
}

.vas-trans .modal .info-section .ref {
    background-color: #e5e3e3;
    padding: 10px;
}

.vas-trans .modal .trans-response {
    width: 400px;
}

.vas-trans .modal .trans-response pre {
    border: 1px solid #bdbcbc;
    padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/vas-transactions/Transactions.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;AAEF;;;GAGG;;AAEH;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB","sourcesContent":[".vas-trans .card-summary {\n  background-color: #ffffff;\n  display: flex;\n  padding: 20px;\n  border-radius: 7px;\n}\n\n.vas-trans .card-summary p {\n  margin-bottom: 0;\n}\n\n.vas-trans .summary-icon {\n  margin-right: auto;\n  margin-left: 0;\n}\n\n.vas-trans .summary-icon img {\n  width: 50px;\n}\n\n.vas-trans .data {\n  text-align: end;\n  font-size: 10px;\n}\n\n.vas-trans .data .amount {\n  font-size: 18px;\n  letter-spacing: 0.1px;\n  color: #000000;\n}\n\n.vas-trans .select-icon .service-logo {\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n}\n\n.vas-trans .data .amount span {\n  font-weight: 600;\n  margin-left: 2px;\n}\n\n.vas-trans .downloads {\n  margin-left: 26px;\n  border: none;\n  padding: 0;\n}\n\n.vas-trans .downloads img {\n  height: 46px;\n}\n\n.vas-trans .date-filter {\n  display: flex;\n  align-items: center;\n}\n\n.vas-trans .date-filter p {\n  margin-bottom: 0;\n  margin-right: 5px;\n  font-size: 10px;\n}\n\n.vas-trans .vas-table {\n  background-color: #ffffff;\n  margin-top: 30px;\n}\n\n.vas-trans .vas-table .btn {\n    font-size: 10px;\n    height: fit-content;\n    padding: 8px;\n  }\n\n/* .vas-trans .vas-table thead {\n    height: 40px;\n    background-color: #9595954E;\n} */\n\n.vas-trans .filter {\n  background-color: transparent;\n  color: #060d27;\n  border: 1px solid #060d27;\n  height: 44px;\n  padding-inline: 20px;\n  margin-left: auto;\n}\n\n.vas-trans .filter:hover {\n  color: #060d27;\n}\n\n.vas-trans .filter-data {\n  display: flex;\n  margin-bottom: 0;\n  gap: 0;\n}\n\n.vas-trans .filter-data .grouped-input {\n  margin-inline: 12px;\n}\n\n.vas-trans .modal .transaction-info {\n  display: flex;\n  font-size: 14px;\n  font-weight: 100;\n  text-align: left;\n  gap: 20px;\n}\n\n.vas-trans .modal .info-section .info-item {\n    margin-bottom: 20px;\n}\n\n.vas-trans .modal .info-section .ref {\n    background-color: #e5e3e3;\n    padding: 10px;\n}\n\n.vas-trans .modal .trans-response {\n    width: 400px;\n}\n\n.vas-trans .modal .trans-response pre {\n    border: 1px solid #bdbcbc;\n    padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
